import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CheckService } from '../check/check.service';
import { CheckType } from '../enums/check-type.enum';
import { PaymentType } from '../enums/payment-type.enum';
import { PaymentService } from '../services/payment.service';
import { ErrorType } from 'src/app/shared/enums/error-type.enum';
import { StorageUtils } from 'src/app/shared/utils/storage-utils';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  /* User Input & System Info */
  paymentType: PaymentType = PaymentType.CreditCard;

  insurancePayBank = new FormControl(null, Validators.required);
  insurancePayAccount = new FormControl(null, [Validators.required, Validators.pattern('^[\\d]{0,16}$')]);
  isAutoBillchnl = new FormControl(false, Validators.required);

  /** 取得活期帳戶銀行名單、保費以及投保日 (由step1所記錄) */
  info$ = this.paymentService.getBankListAndPremiumsInfo().pipe(map(res => res.payload.body));

  isfundrich$ = this.route.data.pipe(map(data => data.isfundrich));

  get PaymentType() { return PaymentType }

  constructor(
    private paymentService: PaymentService,
    private checkService: CheckService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  /*
  * 提交活期帳戶扣款
  * */
  onSubmit() {
    const errMsg = [];
    if (this.insurancePayBank.invalid) errMsg.push('請選擇匯款銀行');
    if (this.insurancePayAccount?.errors?.required) errMsg.push('請輸入匯款帳號');
    if (this.insurancePayAccount?.errors?.pattern) errMsg.push('請輸入正確的帳號');
    if (errMsg.length > 0) {
      this.checkService.notify(CheckType.WARNING, errMsg.join('<br>'), () => {
      });
      return;
    }
    // 避免重複扣款
    let atm = StorageUtils.getInstance().getFromSessionStorage('paymentService.atm');
    if (atm) {
      this.checkService.notify(CheckType.DECLINATURE, ErrorType._A0002, () => { });
      return;
    }
    this.paymentService.debitFromAccount(this.insurancePayBank.value, this.insurancePayAccount.value).subscribe((res) => {
      if (!res.succeeded && res.code === 'A0002') {
        StorageUtils.getInstance().setToSessionStorage('paymentService.atm', true);
        this.checkService.notify(CheckType.DECLINATURE, ErrorType._A0002, () => { });
        return;
      } else {
        this.next();
      }
    });
  }

  /************************************** 活期帳戶付款 | 信用卡付款 **************************************/

  /*
  * 首續期保費自動付款
  * */
  applyAutoBillchnl() {
    const value = this.isAutoBillchnl.value ? 'Y' : 'N';
    // 首續期保費自動依信用卡付款所使用的信用卡資訊進行付款
    this.paymentService.applyAutoBillchnl(value).subscribe(res => {
      // 原Code不處理回傳值
      const ret = res.payload.body.ret;
      console.log('applyAutoBillchnl return: ' + ret);
      this.redirectToHpp();
    })
  }
  /*
  * 取得NccKey並轉導到HPP頁面，此時無法改變付款方式
  * */
  redirectToHpp() {
    this.paymentService.getNccKeyAndUrl().pipe(map(res => res.payload.body)).subscribe(res => {
      const txnUrl = res.txnUrl;
      const nccKey = res.nccKey;
      const hpp = `${txnUrl}?ManTransId=${nccKey}`;
      console.log('Redirecting to Hpp which URL is: ' + hpp);
      document.location.href = hpp;
    });
  }

  payBy(tyep: PaymentType) {
    this.paymentType = tyep;
  }

  /* Pagination */
  next() {
    this.router.navigate(['../step5'], { relativeTo: this.route });
  }

}
